import React, { useEffect, useState } from "react";
import "./Pool_sec.css";
import { useAccount, useBalance } from "wagmi";
import Web3 from "web3";
import {
  prepareWriteContract,
  waitForTransaction,
  writeContract,
} from "@wagmi/core";
import {
  Staking_Abi,
  Staking_Address,
  Token_Abi,
  Token_Address,
} from "../../util/Contract";
import { toast } from "react-hot-toast";

const Pool_sec = () => {
  const [getInput, setgetInput] = useState("");
  const [plan, setplan] = useState(0);
  const { address } = useAccount();
  const [spinner, setspinner] = useState(false);

  let WebSupply = new Web3("https://rpc.mevblocker.io");  //https://rpc.mevblocker.io //https://eth-sepolia.public.blastapi.io

  const Stake = async (Lockable_days) => {
    try {
      if (!address) {
        toast.error("Connect Wallet First");
      } else {
        let stakingContractOf = new WebSupply.eth.Contract(
          Staking_Abi,
          Staking_Address
        );

        let minimumDeposit = await stakingContractOf.methods
          .minimumDeposit()
          .call();
        minimumDeposit = WebSupply.utils.fromWei(minimumDeposit.toString());

        if (getInput == 0 || getInput < minimumDeposit) {
          toast.error(
            getInput == 0
              ? "Please Enter Token Value"
              : getInput < minimumDeposit
              ? `Please Enter Token Value Greater than ${minimumDeposit}`
              : ""
          );
        } else {
          setspinner(true);

          let values = WebSupply.utils.toWei(getInput);

          const { request } = await prepareWriteContract({
            address: Token_Address,
            abi: Token_Abi,
            functionName: "approve",
            args: [Staking_Address, values],
            account: address,
          });
          const { hash } = await writeContract(request);
          const data = await waitForTransaction({
            hash,
          });
          setTimeout(() => {
            setspinner(false);
            toast.success("Approve SuccessFully");
            Staking_Fuc(values, Lockable_days);
          }, 2000);
        }
      }
    } catch (error) {
      setspinner(false);
      console.log(error);
    }
  };

  const Staking_Fuc = async (value, Lockable_days) => {
    try {
      setspinner(true);

      const { request } = await prepareWriteContract({
        address: Staking_Address,
        abi: Staking_Abi,
        functionName: "farm",
        args: [value, Lockable_days],
        account: address,
      });
      const { hash } = await writeContract(request);
      const data = await waitForTransaction({
        hash,
      });

      setTimeout(() => {
        setspinner(false);
        toast.success("Transaction Completed");
      }, 4000);
    } catch (error) {
      console.log(error);
      setspinner(false);
    }
  };

  const get_token_bl=async()=>{
    try {
      let tokenContractOf = new WebSupply.eth.Contract(
        Token_Abi,
        Token_Address
      );
      let tokenBalance = await tokenContractOf.methods.balanceOf(address).call();
      tokenBalance = WebSupply.utils.fromWei(tokenBalance.toString());
    
      setgetInput(tokenBalance)
      
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <div>
      <div className="container">
        <div className="MuiBox-root css-2etnu2">
          <div className="card">
            <div className="MuiBox-root css-11az635">
              <img
                className="MuiBox-root css-1o7w8lq"
                src="https://cryptologos.cc/logos/bone-shibaswap-bone-logo.png?v=026"
                alt=""
              />
              <div className="MuiStack-root css-bimwmu">
                <h6 className="MuiTypography-root MuiTypography-subtitle1 css-ggrk9l">
                  APR
                </h6>
                <h6 className="MuiTypography-root MuiTypography-subtitle1 css-11pyxb5">
                  89%
                </h6>
              </div>
              <div className="MuiStack-root css-1drd8pl">
                <h6 className="MuiTypography-root MuiTypography-subtitle1 css-ggrk9l">
                  Lock Duration
                </h6>
                <h6 className="MuiTypography-root MuiTypography-subtitle1 css-11pyxb5">
                  14 Days
                </h6>
              </div>
              <div className="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root css-m5h15k">
                <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-sizeSmall MuiInputBase-adornedEnd css-segi59">
                  <input
                    aria-invalid="false"
                    id=":r0:"
                    placeholder="Enter Alterna to Stake"
                    type="text"
                    className="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputSizeSmall MuiInputBase-inputAdornedEnd css-b52kj1"
                    value={plan==14? getInput:""}
                    onChange={(e) => (setgetInput(e.target.value), setplan(14))}
                  />
                  <div className="MuiBox-root css-1fmwmta" onClick={()=>(get_token_bl(),setplan(14))}>Max</div>
                  <fieldset
                    aria-hidden="true"
                    className="MuiOutlinedInput-notchedOutline css-igs3ac"
                  >
                    <legend className="css-ihdtdm">
                      <span className="notranslate">​</span>
                    </legend>
                  </fieldset>
                </div>
              </div>
              <button
                className="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-4hkj1c"
                type="button"
                onClick={() => Stake(14)}
              >
                {spinner && plan == 14 ? "Loading..." : "stake"}

                <span className="MuiTouchRipple-root css-w0pj6f" />
              </button>
            </div>
            <div className="card-footer p-0">
            <p className="text-center text-white footer_card">You are {plan==14? getInput:"0"} Staking for 14 days and you will get extra  {plan==14 ? parseFloat((getInput*89)/100).toFixed(2):"0"}</p>
            </div>
          </div>
          {/* </div> */}
          {/* <div className="col-md-6"> */}
          <div className="card">
            <div className="MuiBox-root css-11az635">
              <img
                className="MuiBox-root css-1o7w8lq"
                src="https://cryptologos.cc/logos/bone-shibaswap-bone-logo.png?v=026"
                alt=""
              />
              <div className="MuiStack-root css-bimwmu">
                <h6 className="MuiTypography-root MuiTypography-subtitle1 css-ggrk9l">
                  APR
                </h6>
                <h6 className="MuiTypography-root MuiTypography-subtitle1 css-11pyxb5">
                  279%
                </h6>
              </div>
              <div className="MuiStack-root css-1drd8pl">
                <h6 className="MuiTypography-root MuiTypography-subtitle1 css-ggrk9l">
                  Lock Duration
                </h6>
                <h6 className="MuiTypography-root MuiTypography-subtitle1 css-11pyxb5">
                  30 Days
                </h6>
              </div>
              <div className="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root css-m5h15k">
                <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-colorPrimary MuiInputBase-fullWidth MuiInputBase-formControl MuiInputBase-sizeSmall MuiInputBase-adornedEnd css-segi59">
                  <input
                    aria-invalid="false"
                    id=":r1:"
                    placeholder="Enter Alterna to Stake"
                    type="text"
                    className="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputSizeSmall MuiInputBase-inputAdornedEnd css-b52kj1"
                    value={plan==30? getInput:""}
                    onChange={(e) => (setgetInput(e.target.value), setplan(30))}
                  />
                  <div className="MuiBox-root css-1fmwmta" onClick={()=>(get_token_bl(),setplan(30))}>Max</div>
                  <fieldset
                    aria-hidden="true"
                    className="MuiOutlinedInput-notchedOutline css-igs3ac"
                  >
                    <legend className="css-ihdtdm">
                      <span className="notranslate">​</span>
                    </legend>
                  </fieldset>
                </div>
              </div>
              <button
                className="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-4hkj1c"
                type="button"
                onClick={() => Stake(30)}
              >
                {spinner && plan == 30 ? "Loading..." : "stake"}

                <span className="MuiTouchRipple-root css-w0pj6f" />
              </button>
            </div>
            <div className="card-footer p-0">
              <p className="text-center text-white footer_card ">You are {plan==30 ? getInput:"0"} Staking for 30 days and you will get {plan==30? parseFloat((getInput*179)/100).toFixed(2):"0"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pool_sec;
